// /opt/isp_erp/frontend/src/pages/admin/finanzas/ReportesFinanzas.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ReportesFinanzas.css';

export default function ReportesFinanzas() {
  const navigate = useNavigate();

  const reportes = [
    {
      id: 'ingresos',
      titulo: '📈 Ingresos',
      descripcion: 'Reporte de ingresos por período',
      icono: '📈',
      color: 'ingresos',
      ruta: '/finanzas/reportes/ingresos'
    },
    {
      id: 'cartera',
      titulo: '📊 Cartera',
      descripcion: 'Análisis de cartera por cliente',
      icono: '📊',
      color: 'cartera',
      ruta: '#'
    },
    {
      id: 'mora',
      titulo: '💰 Mora',
      descripcion: 'Reporte de mora y facturas vencidas',
      icono: '💰',
      color: 'mora',
      ruta: '#'
    },
    {
      id: 'facturacion',
      titulo: '📄 Facturación',
      descripcion: 'Resumen de facturación mensual',
      icono: '📄',
      color: 'facturacion',
      ruta: '#'
    },
    {
      id: 'pagos',
      titulo: '💳 Pagos',
      descripcion: 'Reporte de pagos recibidos',
      icono: '💳',
      color: 'pagos',
      ruta: '#'
    },
    {
      id: 'promesas',
      titulo: '📅 Promesas',
      descripcion: 'Seguimiento de promesas de pago',
      icono: '📅',
      color: 'promesas',
      ruta: '#'
    }
  ];

  return (
    <div className="reportes-container">
      {/* Header */}
      <div className="reportes-header">
        <div className="reportes-header-left">
          <div className="reportes-header-icon">📊</div>
          <div>
            <h1>Reportes Financieros</h1>
            <p>Análisis y estadísticas financieras</p>
          </div>
        </div>
      </div>

      {/* Grid de reportes */}
      <div className="reportes-grid">
        {reportes.map((reporte) => (
          <div
            key={reporte.id}
            className={`reporte-card reporte-${reporte.color}`}
            onClick={() => reporte.ruta !== '#' && navigate(reporte.ruta)}
          >
            <div className="reporte-icon">{reporte.icono}</div>
            <div className="reporte-contenido">
              <h3 className="reporte-titulo">{reporte.titulo}</h3>
              <p className="reporte-descripcion">{reporte.descripcion}</p>
            </div>
            <div className="reporte-arrow">→</div>
          </div>
        ))}
      </div>

      {/* Sección de estadísticas rápidas */}
      <div className="reportes-stats">
        <h2>Resumen Rápido</h2>
        <div className="stats-grid">
          <div className="stat-item">
            <span className="stat-label">Facturas por cobrar</span>
            <span className="stat-value">$45,230.00</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Pagos del mes</span>
            <span className="stat-value">$28,450.00</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Promesas activas</span>
            <span className="stat-value">12</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Mora promedio</span>
            <span className="stat-value">8 días</span>
          </div>
        </div>
      </div>

      {/* Nota informativa */}
      <div className="reportes-nota">
        <span className="nota-icon">💡</span>
        <span className="nota-texto">
          Los reportes se generan en tiempo real con los datos actualizados del sistema
        </span>
      </div>
    </div>
  );
}
